export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20artwork%20with%20warm%20orange%20and%20golden%20gradient%20background%2C%20abstract%20manga%20panel%20textures%2C%20soft%20glowing%20light%20effects%2C%20cinematic%20composition%2C%20energetic%20atmosphere%2C%20modern%20Japanese%20pop%20art%20aesthetic%2C%20clean%20minimal%20design%20elements%2C%20warm%20toned%20illustration%20with%20dynamic%20flowing%20shapes&width=1600&height=900&seq=hero-bg-anime-01&orientation=landscape"
          alt="香蕉动漫主题背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 mb-5">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-xs md:text-sm font-medium text-accent-200 whitespace-nowrap">每日更新 · 万部漫画在线畅读</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
              香蕉动漫 - 海量免费漫画在线阅读平台
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 mb-3 font-label">
              下拉式阅读更流畅 · 随时随地免费畅读
            </p>

            <p className="text-sm md:text-base text-background-50/65 max-w-xl mx-auto lg:mx-0 leading-relaxed mb-8">
              香蕉动漫汇聚韩漫、日漫、国漫、条漫等多元类型，打造完全免费的漫画在线阅读平台。每日同步更新热门连载，无需注册付费即可畅享下拉式沉浸阅读体验，是二次元爱好者必备的免费漫画大全入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/20">
                  <i className="ri-book-open-line text-primary-300 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg md:text-xl font-heading text-background-50">30,000+</div>
                  <div className="text-xs text-background-50/55">漫画资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500/20">
                  <i className="ri-user-heart-line text-accent-300 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg md:text-xl font-heading text-background-50">500万+</div>
                  <div className="text-xs text-background-50/55">活跃读者</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-500/20">
                  <i className="ri-timer-flash-line text-secondary-300 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg md:text-xl font-heading text-background-50">每日更新</div>
                  <div className="text-xs text-background-50/55">同步连载</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#index');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-compass-3-line"></i>
                探索热门专题
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#ranking');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium rounded-lg border border-background-50/25 transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-trophy-line"></i>
                查看人气榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20style%20illustration%20featuring%20a%20young%20adventurer%20reading%20comics%20on%20a%20tablet%2C%20surrounded%20by%20floating%20manga%20panels%20and%20speech%20bubbles%2C%20warm%20orange%20and%20coral%20color%20scheme%2C%20modern%20flat%20illustration%20with%20clean%20lines%2C%20vibrant%20pop%20art%20style%2C%20energetic%20composition%2C%20soft%20gradient%20background&width=800&height=1000&seq=hero-main-02&orientation=portrait"
                alt="香蕉动漫阅读体验主视觉"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '4/5' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}